import {
  Box,
  Button,
  Flex,
  FormControl, FormLabel,
  HStack,
  Input,
  Link,
  Select,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
import React, {useMemo} from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import Moment from 'moment';

// Custom components
import Card from "components/card/Card";

// Assets
import InvoiceStatus from "../invoice/InvoiceStatus";
import {DownloadIcon} from "@chakra-ui/icons";

export default function ColumnsTable(props) {
  const { columnsData, tableData } = props;

  const columns = useMemo(() => columnsData, [columnsData]);
  const data = useMemo(() => tableData, [tableData]);

  const initialState = {
    pageSize: 10,
    pageIndex: 0
  };

  const tableInstance = useTable(
      {
        columns,
        data,
        initialState
      },
      useGlobalFilter,
      useSortBy,
      usePagination,
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: {pageIndex, pageSize},
    setGlobalFilter
  } = tableInstance;

  const handleSetSearchTerm = (searchTerm) => {
    setGlobalFilter(searchTerm)
  };

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  return (
    <Card
      direction='column'
      w='100%'
      px='0px'
      overflowX={{ sm: "scroll", lg: "hidden" }}>

      <FormControl width={200} mb='24px' ml={'auto'} mr={5} display='flex' alignItems={'center'}>
        <FormLabel
            ms='4px'
            fontSize='sm'
            fontWeight='500'
            color={textColor}
            htmlFor='title'
        >
          Suche
        </FormLabel>
        <Input
            id='title'
            fontSize='sm'
            type='text'
            fontWeight='500'
            size='lg'
            onChange={(e) => handleSetSearchTerm(e.target.value)}
        />
      </FormControl>

      <Table {...getTableProps()} variant='simple' color='gray.500' mb='24px'>
        <Thead>
          {headerGroups.map((headerGroup, index) => (
            <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
              {headerGroup.headers.map((column, index) => (
                <Th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  pe='10px'
                  key={index}
                  borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color='gray.400'>
                    {column.render("Header")}
                  </Flex>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()}>
          {page.map((row, index) => {
            prepareRow(row);
            return (
              <Tr {...row.getRowProps()} key={index}>
                {row.cells.map((cell, index) => {
                  let data;
                  if (cell.column.Header === "OBJEKT") {
                    data = (
                      <Text color={textColor} fontSize='sm' fontWeight='700'>{cell.value}</Text>
                    );
                  } else if (cell.column.Header === "STATUS") {
                    data = (
                        <Flex align='center'>
                          <InvoiceStatus status={cell.value}/>
                        </Flex>
                    );
                  } else if (cell.column.Header === "BETRAG") {
                    data = (
                        <Flex align='center'>
                          <Text>{cell.value} €</Text>
                        </Flex>
                    );
                  } else if (cell.column.Header === "GÜLTIG BIS") {
                    data = (
                      <Text color={textColor} fontSize='sm' fontWeight='700'>
                        {Moment(cell.value).format('DD.MM.YYYY HH:mm')}
                      </Text>
                    );
                  } else if (cell.column.Header === "DOWNLOAD") {
                    data = (
                        <Link isExternal href={cell.value}>Rechnung herunterladen <DownloadIcon mx='2px' /></Link>
                    );
                  } else{
                    data = (
                        <Text>
                          {cell.value}
                        </Text>
                    );
                  }
                  return (
                    <Td
                      {...cell.getCellProps()}
                      key={index}
                      fontSize={{ sm: "14px" }}
                      minW={{ sm: "150px", md: "200px", lg: "auto" }}
                      borderColor='transparent'>
                      {data}
                    </Td>
                  );
                })}
              </Tr>
            );
          })}
        </Tbody>
      </Table>

      <Box className="pagination" mt={4}>
        <Flex alignItems={'center'} justifyContent="space-between" gap={{base:5, lg:20}} px={5} direction={{base: "column", lg: 'row'}}>
          <HStack spacing={4}>
            <Button onClick={() => gotoPage(0)} disabled={!canPreviousPage} colorScheme="brand" size="sm">
              {"<<"}
            </Button>
            <Button onClick={() => previousPage()} disabled={!canPreviousPage} colorScheme="brand"
                    size="sm">
              {"<"}
            </Button>
            <Button onClick={() => nextPage()} disabled={!canNextPage} colorScheme="brand" size="sm">
              {">"}
            </Button>
            <Button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage} colorScheme="brand"
                    size="sm">
              {">>"}
            </Button>
          </HStack>

          <Text>
            <strong>
              {pageIndex + 1} von {pageOptions.length}
            </strong>
          </Text>

          <HStack spacing={4}>

            <Text>Seite: </Text>
            <Input
                type="number"
                defaultValue={pageIndex + 1}
                onChange={(e) => {
                  const page = e.target.value ? Number(e.target.value) - 1 : 0;
                  gotoPage(page);
                }}
                width="100px"
                size="sm"
            />
            <Select
                value={pageSize}
                onChange={(e) => setPageSize(Number(e.target.value))}
                width="fit-content"
                size="sm"
            >
              {[10, 20, 30, 40, 50].map((pageSize) => (
                  <option key={pageSize} value={pageSize}>
                    Zeige {pageSize}
                  </option>
              ))}
            </Select>
          </HStack>

        </Flex>
      </Box>
    </Card>
  );
}
